export default {"src":"/_next/static/media/menu.7e3ab44d.svg","height":14,"width":25,"blurWidth":0,"blurHeight":0};